export default __webpack_public_path__ + "static/media/bacqueville12.dd168f32.jpg";